import { useEffect, useState } from 'react';
import { usePageData } from '@/contexts/pageContext';

export const useLoadSagePay = () => {
  const [isSagePayScriptLoaded, setIsSagePayScriptLoaded] = useState(false);
  const { urls } = usePageData();

  useEffect(() => {
    const script = document.createElement('script');
    script.src = urls.sagePayScript ?? '';
    script.async = true;
    script.onerror = () => {
      console.error('Failed to load SagePay script.');
    };
    script.onload = () => setIsSagePayScriptLoaded(true);

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [urls.sagePayScript]);

  return { isSagePayScriptLoaded };
};
